import React from 'react';
import Cookies from 'js-cookie';
import { ActivityCalendar } from 'react-activity-calendar';
import { FiActivity, FiAward, FiBox, FiBriefcase, FiCalendar, FiCheckCircle, FiClock, FiLoader, FiLogOut, FiMapPin, FiMoreVertical, FiPlus, FiThumbsUp, FiTrendingUp, FiUser, FiUserPlus, FiX } from 'react-icons/fi';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import styles from './Dashboard.module.css';
import * as utils from '../../utils/utils';
import Sidebar from '../Sidebar/Sidebar';
import HQDialog from '../HQDialog/HQDialog';

export default class Dashboard extends React.Component {

	constructor(props) {
		super(props);

		this.screens = {
			checkIns: 1,
			experience: 2,
			education: 3,
		};

		this.state = {
			isLoading: true,
			isResumeProcessing: false,
			isLoadingMore: false,
			errorText: '',
			isLoadingExperience: false,
			isLoadingEducation: false,
			isSavingEducation: false,
			isSavingExperience: false,
			hasLoadedExperience: false,
			hasLoadedEducation: false,
			experienceErrorText: '',
			educationErrorText: '',
			saveExperienceErrorText: '',
			saveEducationErrorText: '',
			currentScreen: this.screens.checkIns,
			isAddExperienceDialogOpen: false,
			isAddEducationDialogOpen: false,
			newExperienceText: '',
			newEducationText: '',
			openLiveResumeMenuID: 0,
			deletingLiveResumeIDs: [],
			confirmDeleteLiveResumeID: 0,

			firstName: '',
			lastName: '',
			inviteCode: '',
			numInvitesLeft: 0,
			contributionGraph: {},
			totalContributions: 0,
			recentLiveResumes: [],
			experienceList: [],
			educationList: [],

			offset: 0,
			limit: 5,
			hasMore: false,
		};

		this.sampleSparklineData = [
			{ date: "Wk 1", checkins: 4 },
			{ date: "Wk 2", checkins: 7 },
			{ date: "Wk 3", checkins: 5 },
			{ date: "Wk 4", checkins: 9 },
			{ date: "Wk 5", checkins: 12 },
			{ date: "Wk 6", checkins: 6 },
			{ date: "Wk 7", checkins: 8 },
			{ date: "Wk 8", checkins: 14 },
			{ date: "Wk 9", checkins: 11 },
			{ date: "Wk 10", checkins: 15 },
			{ date: "Wk 11", checkins: 10 },
			{ date: "Wk 12", checkins: 18 }
		];

		this.liveResumeMenuRefs = {};
	}

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		document.addEventListener('mousedown', this.onDocumentPointerDown);
		document.addEventListener('touchstart', this.onDocumentPointerDown);

		this.loadDashboardData();
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.onDocumentPointerDown);
		document.removeEventListener('touchstart', this.onDocumentPointerDown);
	}

	getUserIDKey = () => {
		if (utils.isDev) {
			return 'User-Id-Dev';
		}

		return 'User-Id';
	};

	getCurrentUserID = () => {
		const userID = Cookies.get(this.getUserIDKey());
		return Number(userID);
	};

	// normalizeCalendarData = (graph) => {
	// 	const maxCount = graph.reduce((max, item) => {
	// 		return Math.max(max, item.count || 0);
	// 	}, 0);

	// 	return graph.map((item) => {
	// 		const count = Number(item.count) || 0;

	// 		let level = 0;
	// 		if (count > 0 && maxCount > 0) {
	// 			level = Math.min(4, Math.max(1, Math.ceil((count / maxCount) * 4)));
	// 		}

	// 		return {
	// 			date: item.day,
	// 			count,
	// 			level,
	// 		};
	// 	});
	// };

	loadDashboardData = () => {
		const userID = this.getCurrentUserID();

		if (!Number.isInteger(userID) || userID <= 0) {
			this.setState({
				isLoading: false,
				isLoadingExperience: false,
				isLoadingEducation: false,
				errorText: 'Could not identify your account. Please sign in again.',
			});
			return;
		}

		Promise.all([
			utils.sendRequest('/meta/getIsAResumeProcessing', {}),
			utils.sendRequest('/profile/getUserProfile', { userID }),
			utils.sendRequest('/profile/getUserContributionGraph', { userID }),
			utils.sendRequest('/liveResume/getRecentLiveResumeUpdates', { userID, offset: 0 }),
		])
			.then(([
				metaResponse,
				profileResponse,
				contributionResponse,
				updatesResponse
			]) => {
				const isResumeProcessing = Boolean(metaResponse.isAResumeProcessing);
				// const contributionGraph = this.normalizeCalendarData(contributionResponse.contributionGraph || []);
				const contributionGraph = contributionResponse || {};

				const recentLiveResumes = updatesResponse.recentLiveResumes || [];

				this.setState({
					isLoading: false,
					errorText: '',

					isResumeProcessing,

					firstName: profileResponse.firstName || '',
					lastName: profileResponse.lastName || '',
					inviteCode: profileResponse.inviteCode || '',
					numInvitesLeft: profileResponse.numInvitesLeft || 0,
					contributionGraph,
					totalContributions: contributionResponse.totalContributions || 0,
					recentLiveResumes,

					offset: recentLiveResumes.length,
					limit: updatesResponse.limit || 5,
					hasMore: recentLiveResumes.length === (updatesResponse.limit || 5),
				});
			})
			.catch((error) => {
				console.log('dashboard load error', error);

				this.setState({
					isLoading: false,
					errorText: 'Could not load dashboard data right now. Please try again shortly.',
				});
			});
	};

	loadExperienceData = (userID) => {
		this.setState({
			isLoadingExperience: true,
			experienceErrorText: '',
		});

		utils.sendRequest('/entity/getUserExperienceList', { userID })
			.then((responseData) => {
				this.setState({
					isLoadingExperience: false,
					hasLoadedExperience: true,
					experienceList: responseData.experienceList || [],
				});
			})
			.catch((error) => {
				console.log('experience load error', error);
				this.setState({
					isLoadingExperience: false,
					experienceErrorText: 'Could not load experience right now.',
				});
			});
	};

	loadEducationData = (userID) => {
		this.setState({
			isLoadingEducation: true,
			educationErrorText: '',
		});

		utils.sendRequest('/education/getUserEducationList', { userID })
			.then((responseData) => {
				this.setState({
					isLoadingEducation: false,
					hasLoadedEducation: true,
					educationList: responseData.educationList || [],
				});
			})
			.catch((error) => {
				console.log('education load error', error);
				this.setState({
					isLoadingEducation: false,
					educationErrorText: 'Could not load education right now.',
				});
			});
	};

	openAddEducationDialog = () => {
		this.setState({
			isAddEducationDialogOpen: true,
			saveEducationErrorText: '',
		});
	};

	openAddExperienceDialog = () => {
		this.setState({
			isAddExperienceDialogOpen: true,
			saveExperienceErrorText: '',
		});
	};

	closeAddEducationDialog = () => {
		this.setState({
			isAddEducationDialogOpen: false,
			saveEducationErrorText: '',
		});
	};

	closeAddExperienceDialog = () => {
		this.setState({
			isAddExperienceDialogOpen: false,
			saveExperienceErrorText: '',
		});
	};

	onNewEducationTextChange = (event) => {
		this.setState({
			newEducationText: event.target.value,
		});
	};

	onNewExperienceTextChange = (event) => {
		this.setState({
			newExperienceText: event.target.value,
		});
	};

	isLiveResumeDeleting = (liveResumeID) => {
		return (this.state.deletingLiveResumeIDs || []).includes(liveResumeID);
	};

	setLiveResumeMenuRef = (liveResumeID, node) => {
		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			return;
		}

		if (node) {
			this.liveResumeMenuRefs[liveResumeID] = node;
			return;
		}

		delete this.liveResumeMenuRefs[liveResumeID];
	};

	onDocumentPointerDown = (event) => {
		const openLiveResumeMenuID = Number(this.state.openLiveResumeMenuID);

		if (!Number.isInteger(openLiveResumeMenuID) || openLiveResumeMenuID <= 0) {
			return;
		}

		const activeMenuRoot = this.liveResumeMenuRefs[openLiveResumeMenuID];
		if (!activeMenuRoot) {
			this.setState({
				openLiveResumeMenuID: 0,
			});
			return;
		}

		if (activeMenuRoot.contains(event.target)) {
			return;
		}

		this.setState({
			openLiveResumeMenuID: 0,
		});
	};

	toggleLiveResumeMenu = (liveResumeID) => {
		this.setState((prevState) => ({
			openLiveResumeMenuID: prevState.openLiveResumeMenuID === liveResumeID ? 0 : liveResumeID,
		}));
	};

	openDeleteLiveResumeDialog = (item) => {
		const liveResumeID = Number(item.userEntityLiveResumeId);

		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0 || this.isLiveResumeDeleting(liveResumeID)) {
			return;
		}

		this.setState({
			openLiveResumeMenuID: 0,
			confirmDeleteLiveResumeID: liveResumeID,
		});
	};

	closeDeleteLiveResumeDialog = () => {
		this.setState({
			confirmDeleteLiveResumeID: 0,
		});
	};

	onDeleteLiveResumeDialogPrimaryClick = () => {
		const liveResumeID = Number(this.state.confirmDeleteLiveResumeID);

		this.setState({
			confirmDeleteLiveResumeID: 0,
		}, () => {
			this.deleteLiveResume(liveResumeID);
		});
	};

	deleteLiveResume = (liveResumeIDInput) => {
		const liveResumeID = Number(liveResumeIDInput);

		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0 || this.isLiveResumeDeleting(liveResumeID)) {
			return;
		}

		this.setState((prevState) => ({
			openLiveResumeMenuID: 0,
			confirmDeleteLiveResumeID: 0,
			deletingLiveResumeIDs: Array.from(new Set([...prevState.deletingLiveResumeIDs, liveResumeID])),
			errorText: '',
		}), () => {
			utils.sendRequest('/liveResume/deleteLiveResume', {
				userEntityLiveResumeID: liveResumeID,
			})
				.then(() => {
					this.setState((prevState) => ({
						recentLiveResumes: prevState.recentLiveResumes.filter((resume) => Number(resume.userEntityLiveResumeId) !== liveResumeID),
						deletingLiveResumeIDs: prevState.deletingLiveResumeIDs.filter((resumeID) => resumeID !== liveResumeID),
					}));
				})
				.catch((error) => {
					console.log('delete live resume error', error);

					this.setState((prevState) => ({
						deletingLiveResumeIDs: prevState.deletingLiveResumeIDs.filter((resumeID) => resumeID !== liveResumeID),
						errorText: error && error.message ? error.message : 'Could not delete the live resume right now.',
					}));
				});
		});
	};

	onAddEducationSave = () => {
		const userID = this.getCurrentUserID();
		const normalizedEducationText = (this.state.newEducationText || '').trim();

		if (!Number.isInteger(userID) || userID <= 0) {
			this.setState({
				saveEducationErrorText: 'Could not identify your account. Please sign in again.',
			});
			return;
		}

		if (normalizedEducationText === '') {
			this.setState({
				saveEducationErrorText: 'Please enter your education details before adding.',
			});
			return;
		}

		this.setState({
			isAddEducationDialogOpen: false,
			isSavingEducation: true,
			saveEducationErrorText: '',
			newEducationText: '',
		}, () => {
			utils.sendRequest('/education/saveEducation', {
				userID,
				education: normalizedEducationText,
			})
				.then(() => {
					this.setState({
						isSavingEducation: false,
						hasLoadedEducation: true,
					});

					this.loadEducationData(userID);
				})
				.catch((error) => {
					console.log('save education error', error);
					this.setState({
						isSavingEducation: false,
						saveEducationErrorText: 'Could not add education right now. Please try again shortly.',
					});
				});
		});
	};

	onAddExperienceSave = () => {
		const userID = this.getCurrentUserID();
		const normalizedExperienceText = (this.state.newExperienceText || '').trim();

		if (!Number.isInteger(userID) || userID <= 0) {
			this.setState({
				saveExperienceErrorText: 'Could not identify your account. Please sign in again.',
			});
			return;
		}

		if (normalizedExperienceText === '') {
			this.setState({
				saveExperienceErrorText: 'Please enter your work experience details before adding.',
			});
			return;
		}

		this.setState({
			isAddExperienceDialogOpen: false,
			isSavingExperience: true,
			saveExperienceErrorText: '',
			newExperienceText: '',
		}, () => {
			utils.sendRequest('/entity/saveExperience', {
				userID,
				experience: normalizedExperienceText,
			})
				.then(() => {
					this.setState({
						isSavingExperience: false,
						hasLoadedExperience: true,
					});

					this.loadExperienceData(userID);
				})
				.catch((error) => {
					console.log('save experience error', error);
					this.setState({
						isSavingExperience: false,
						saveExperienceErrorText: 'Could not add experience right now. Please try again shortly.',
					});
				});
		});
	};

	loadMoreUpdates = () => {
		const {
			limit,
			isLoadingMore,
		} = this.state;

		if (isLoadingMore) {
			return;
		}

		const userID = this.getCurrentUserID();
		if (!Number.isInteger(userID) || userID <= 0) {
			return;
		}

		this.setState({
			isLoadingMore: true,
		}, () => {
			utils.sendRequest('/liveResume/getRecentLiveResumeUpdates', {
				userID,
				offset: this.state.offset,
			})
				.then((responseData) => {
					const nextItems = responseData.recentLiveResumes || [];
					const nextLimit = responseData.limit || limit;

					this.setState((prevState) => ({
						isLoadingMore: false,
						recentLiveResumes: [...prevState.recentLiveResumes, ...nextItems],
						offset: prevState.offset + nextItems.length,
						limit: nextLimit,
						hasMore: nextItems.length === nextLimit,
					}));
				})
				.catch((error) => {
					console.log('load more updates error', error);
					this.setState({
						isLoadingMore: false,
					});
				});
		});
	};

	onLogoutClick = () => {
		utils.removeAuthDetails();
		window.location.href = '/signin';
	};

	onNewLiveResumeCheckInClick = () => {
		window.location.href = '/live-resume';
	};

	setCurrentScreen = (screen) => {
		if (this.state.currentScreen === screen) {
			return;
		}

		const nextState = {
			currentScreen: screen,
		};

		if (screen === this.screens.experience && !this.state.hasLoadedExperience && !this.state.isLoadingExperience) {
			nextState.isLoadingExperience = true;
			nextState.experienceErrorText = '';
		}

		if (screen === this.screens.education && !this.state.hasLoadedEducation && !this.state.isLoadingEducation) {
			nextState.isLoadingEducation = true;
			nextState.educationErrorText = '';
		}

		this.setState({
			...nextState,
		}, () => {
			const userID = this.getCurrentUserID();

			if (!Number.isInteger(userID) || userID <= 0) {
				return;
			}

			if (screen === this.screens.experience && !this.state.hasLoadedExperience) {
				this.loadExperienceData(userID);
			}

			if (screen === this.screens.education && !this.state.hasLoadedEducation) {
				this.loadEducationData(userID);
			}
		});
	};

	getFullName = () => {
		const {
			firstName,
			lastName,
		} = this.state;

		const fullName = `${firstName} ${lastName}`.trim();
		return fullName === '' ? 'Member' : fullName;
	};

	getInitials = () => {
		const {
			firstName,
			lastName,
		} = this.state;

		const initials = `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`.toUpperCase();
		return initials === '' ? 'ME' : initials;
	};

	// getLatestActiveDate = () => {
	// 	const {
	// 		contributionGraph,
	// 	} = this.state;

	// 	for (let index = contributionGraph.length - 1; index >= 0; index--) {
	// 		if ((contributionGraph[index].count || 0) > 0) {
	// 			return contributionGraph[index].date;
	// 		}
	// 	}

	// 	return 'No activity yet';
	// };

	formatDate = (value) => {
		if (!value) {
			return 'Unknown';
		}

		const date = new Date(value);
		if (Number.isNaN(date.getTime())) {
			return 'Unknown';
		}

		return date.toLocaleDateString(undefined, {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		});
	};

	formatDateRange = (startDate, endDate) => {
		const startLabel = this.formatDate(startDate);
		const endLabel = endDate ? this.formatDate(endDate) : 'Present';

		if (startLabel === 'Unknown' && endLabel === 'Unknown') {
			return 'Dates not available';
		}

		return `${startLabel} - ${endLabel}`;
	};

	formatYear = (value) => {
		if (value === null || value === undefined || value === '') {
			return 'Year not listed';
		}

		return `Class of ${value}`;
	};

	getChipNames = (items) => {
		if (!items || items.length === 0) {
			return [];
		}

		return items.map((item) => item.name).filter(Boolean);
	};

	renderScreenTabs = () => {
		const tabs = [
			{ key: this.screens.checkIns, label: 'Check-Ins', description: 'Dashboard overview' },
			{ key: this.screens.experience, label: 'Experience', description: 'Career history' },
			{ key: this.screens.education, label: 'Education', description: 'Academic background' },
		];

		return (
			<div className={styles.tabBar} role="tablist" aria-label="Dashboard sections">
				{tabs.map((tab) => {
					const isActive = this.state.currentScreen === tab.key;

					return (
						<button
							key={tab.key}
							type="button"
							className={`${styles.tabButton} ${isActive ? styles.tabButtonActive : ''}`}
							role="tab"
							aria-selected={isActive}
							onClick={() => this.setCurrentScreen(tab.key)}
						>
							<span className={styles.tabLabel}>{tab.label}</span>
							<span className={styles.tabDescription}>{tab.description}</span>
						</button>
					);
				})}
			</div>
		);
	};

	renderCheckIns = () => {
		const {
			isLoading,
			isLoadingMore,
			errorText,
			contributionGraph,
			totalContributions,
			recentLiveResumes,
			hasMore,
			numInvitesLeft,
			inviteCode,
		} = this.state;

		return (
			<>
				<div className={styles.sectionHeader}>
					<h2 className={styles.formTitle}><FiUser /> Dashboard Overview</h2>
					<p className={styles.formText}>Track real-time verified activity updates, growth trends, and your live resume ledger.</p>
				</div>

				{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}

				{isLoading && <div className={styles.loadingBox}>Synchronizing profile indices...</div>}

				{!isLoading && (
					<>
						<section className={styles.contentSection}>
							<h3 className={styles.sectionTitle}>Activity Map</h3>
							<div className={styles.activityCard}>
								<div className={styles.activityHeader}>
									<div>
										<span className={styles.activityKpiLabel}>30-Day Momentum</span>
										<h4 className={styles.activityKpiValue}>{contributionGraph.totalContributions} Check-ins</h4>
									</div>
									{/* <span className={styles.activityTrend}>(tbd)+12% vs last month</span> */}
								</div>

								<div className={styles.activityChartContainer}>
									<ResponsiveContainer width="100%" height="100%">
										<BarChart data={contributionGraph.contributionGraph}>
											{contributionGraph.categories.map((cat) => {
												const minHex = 7, maxHex = 15;
												const opacity1 = Math.floor(Math.random() * (maxHex - minHex + 1) + minHex).toString(16);
												const opacity2 = Math.random().toString(8).slice(2, 3);
												return (
													<Bar
														// barSize={10}
														key={cat.careerCategoryId}
														dataKey={`c_${cat.careerCategoryId}`}
														name={cat.categoryName}
														// fill={`#${cat.colorCode}`}
														fill={`#2563eb${opacity1}${opacity2}`}
														// fill={`#2563eb${darkHex}`}
														stackId="a"
													/>
												);
											})}
										</BarChart>
										{/* <AreaChart data={this.sampleSparklineData} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
											<defs>
												<linearGradient id="activityGlow" x1="0" y1="0" x2="0" y2="1">
													<stop offset="5%" stopColor="#2563eb" stopOpacity={0.18} />
													<stop offset="95%" stopColor="#2563eb" stopOpacity={0} />
												</linearGradient>
											</defs>
											<XAxis dataKey="date" hide />
											<Tooltip
												contentStyle={{
													background: 'rgba(15, 23, 42, 0.95)',
													border: '1px solid rgba(255, 255, 255, 0.1)',
													borderRadius: '8px',
													color: '#ffffff',
													fontSize: '12px',
													fontFamily: "'JetBrains Mono', monospace",
													backdropFilter: 'blur(4px)'
												}}
												itemStyle={{ color: '#38bdf8' }}
											/>
											<Area
												type="linear"
												dataKey="checkins"
												stroke="#2563eb"
												strokeWidth={2.5}
												fillOpacity={1}
												fill="url(#activityGlow)"
											/>
										</AreaChart> */}
									</ResponsiveContainer>
								</div>
							</div>
							{/* <ActivityCalendar
								data={contributionGraph}
								blockRadius={3}
								blockSize={12}
								blockMargin={4}
								showWeekdayLabels
								hideColorLegend
								theme={{
									light: ['#f1f5f9', '#cbd5e1', '#94a3b8', '#475569', '#0f172a'],
								}}
								labels={{
									totalCount: '{{count}} items log compiled over trailing 90 days',
								}}
							/> */}
						</section>

						<section className={styles.contentSection}>
							<h3 className={styles.sectionTitle}>Live Resume Streams</h3>

							{recentLiveResumes.length === 0 && (
								<div className={styles.emptyBox}>Stream empty. Initialize live resume entries to populate ledger.</div>
							)}

							<div className={styles.updatesList}>
								{recentLiveResumes.map(this.renderUpdateCard)}
							</div>

							{hasMore && (
								<button
									className={styles.loadMoreButton}
									onClick={this.loadMoreUpdates}
									disabled={isLoadingMore}
								>
									{isLoadingMore ? 'Reading Data...' : 'Fetch Older Entries'}
								</button>
							)}
						</section>
					</>
				)}
			</>
		);
	};

	renderExperiences = () => {
		const {
			isLoadingExperience,
			isSavingExperience,
			experienceErrorText,
			saveExperienceErrorText,
			experienceList,
		} = this.state;

		return (
			<>
				<div className={styles.sectionHeader}>
					<h2 className={styles.formTitle}><FiBriefcase /> Experience</h2>
					<p className={styles.formText}>Career history linked to verified entity records and role updates.</p>
					{isSavingExperience && (
						<div className={styles.statusText}>Adding your new work experience</div>
					)}
				</div>

				{experienceErrorText !== '' && <div className={styles.errorBox}>{experienceErrorText}</div>}
				{saveExperienceErrorText !== '' && <div className={styles.errorBox}>{saveExperienceErrorText}</div>}

				{isLoadingExperience && <div className={styles.loadingBox}>Loading experience records...</div>}

				{!isLoadingExperience && experienceList.length === 0 && (
					<div className={styles.emptyBox}>No experience records were found for this profile.</div>
				)}

				{!isLoadingExperience && experienceList.length > 0 && (
					<div className={styles.profileList}>
						{experienceList.map((item) => (
							<article key={`${item.entityId}-${item.role}-${item.startDate || 'start'}`} className={styles.profileCard}>
								<div className={styles.profileCardHeader}>
									<div className={styles.profileCardHeadingGroup}>
										<h3 className={styles.profileCardTitle}>{item.name || 'Unnamed organization'}</h3>
										<p className={styles.profileCardSubtitle}>{item.role || 'Role not set'}</p>
									</div>
									<span className={styles.profileCardBadge}><FiCalendar /> {this.formatDateRange(item.startDate, item.endDate)}</span>
								</div>

								<p className={styles.profileCardBody}>{item.description || 'No experience description available.'}</p>

								<div className={styles.profileCardMetaRow}>
									{/* <span className={styles.profileCardMetaChip}><FiMapPin /> {item.location || 'Remote'}</span> */}
									<span className={styles.profileCardMetaChip}><FiClock /> {this.formatDate(item.startDate)} - {item.endDate ? this.formatDate(item.endDate) : 'Present'}</span>
								</div>
							</article>
						))}
					</div>
				)}

				<div className={styles.sectionFooterActions}>
					<button
						type="button"
						className={styles.secondaryButton}
						onClick={this.openAddExperienceDialog}
					>
						<FiPlus /> Add Experience
					</button>
				</div>
			</>
		);
	};

	renderEducations = () => {
		const {
			isLoadingEducation,
			isSavingEducation,
			educationErrorText,
			saveEducationErrorText,
			educationList,
		} = this.state;

		return (
			<>
				<div className={styles.sectionHeader}>
					<h2 className={styles.formTitle}><FiAward /> Education</h2>
					<p className={styles.formText}>Academic history, majors, and school records tied to your profile.</p>
					{isSavingEducation && (
						<div className={styles.statusText}>Adding your new education</div>
					)}
				</div>

				{educationErrorText !== '' && <div className={styles.errorBox}>{educationErrorText}</div>}
				{saveEducationErrorText !== '' && <div className={styles.errorBox}>{saveEducationErrorText}</div>}

				{isLoadingEducation && <div className={styles.loadingBox}>Loading education records...</div>}

				{!isLoadingEducation && educationList.length === 0 && (
					<div className={styles.emptyBox}>No education records were found for this profile.</div>
				)}

				{!isLoadingEducation && educationList.length > 0 && (
					<div className={styles.profileList}>
						{educationList.map((item) => (
							<article key={`${item.schoolId}-${item.majorName}-${item.year || 'year'}`} className={styles.profileCard}>
								<div className={styles.profileCardHeader}>
									<div className={styles.profileCardHeadingGroup}>
										<h3 className={styles.profileCardTitle}>{item.name || 'Unnamed school'}</h3>
										<p className={styles.profileCardSubtitle}>{item.majorName || 'Major not listed'}</p>
									</div>
									<span className={styles.profileCardBadge}><FiCalendar /> {this.formatYear(item.year)}</span>
								</div>

								<p className={styles.profileCardBody}>
									{item.degree || 'Degree not listed'}
									{item.focus ? ` • ${item.focus}` : ''}
									{item.description ? ` • ${item.description}` : ''}
								</p>

								<div className={styles.profileCardMetaRow}>
									<span className={styles.profileCardMetaChip}><FiMapPin /> {[item.city, item.state, item.country].filter(Boolean).join(', ') || 'Location not listed'}</span>
									<span className={styles.profileCardMetaChip}><FiAward /> {item.majorName || 'Major not listed'}</span>
								</div>
							</article>
						))}
					</div>
				)}

				<div className={styles.sectionFooterActions}>
					<button
						type="button"
						className={styles.secondaryButton}
						onClick={this.openAddEducationDialog}
					>
						<FiPlus /> Add Education
					</button>
				</div>
			</>
		);
	};

	renderCurrentScreen = () => {
		const {
			currentScreen,
		} = this.state;
	
		if (currentScreen === this.screens.checkIns) {
			return this.renderCheckIns();
		}
		else if (currentScreen === this.screens.experience) {
			return this.renderExperiences();
		}
		else if (currentScreen === this.screens.education) {
			return this.renderEducations();
		}
	};

	renderUpdateCard = (item) => {
		const liveResumeID = Number(item.userEntityLiveResumeId);
		const skillNames = this.getChipNames(item.skills);
		const toolNames = this.getChipNames(item.tools);
		const domainNames = this.getChipNames(item.domains);
		const softSkillNames = this.getChipNames(item.softSkills);
		const impacts = this.getChipNames(item.impacts);
		const achievements = this.getChipNames(item.achievements);
		const isMenuOpen = this.state.openLiveResumeMenuID === liveResumeID;
		const isDeleting = this.isLiveResumeDeleting(liveResumeID);

		return (
			<article key={item.userEntityLiveResumeId} className={`${styles.updateCard}${isDeleting ? ` ${styles.updateCardDeleting}` : ''}`}>
				<div className={styles.updateTopRow}>
					<div className={styles.updateMetaGroup}>
						<span className={styles.metaChip}><FiBox /> {item.careerCategoryName || 'Category Set'}</span>
						{/* <span className={styles.metaChip}><FiMapPin /> {item.location || 'Remote'}</span> */}
						<span className={styles.metaChip}><FiClock /> {this.formatDate(item.createdAt)}</span>
					</div>
					<div className={styles.updateActions} ref={(node) => this.setLiveResumeMenuRef(liveResumeID, node)}>
						<button
							type="button"
							className={styles.updateMenuButton}
							onClick={() => this.toggleLiveResumeMenu(liveResumeID)}
							aria-label="Open live resume actions"
							aria-expanded={isMenuOpen}
							disabled={isDeleting}
						>
							<FiMoreVertical />
						</button>

						{isMenuOpen && (
							<div className={styles.updateMenu} role="menu" aria-label="Live resume actions">
								<button
									type="button"
									className={styles.updateMenuItemDelete}
									onClick={() => this.openDeleteLiveResumeDialog(item)}
									disabled={isDeleting}
									role="menuitem"
								>
									Delete
								</button>
							</div>
						)}
					</div>
				</div>

				<p className={styles.liveResumeText}>{item.liveResumeText || 'No live resume update text available.'}</p>

				{(
					domainNames.length > 0 ||
					skillNames.length > 0 ||
					toolNames.length > 0 ||
					softSkillNames.length > 0 ||
					impacts.length > 0 ||
					achievements.length > 0
				) && (
					<div className={styles.tagWrapperGrid}>
						{domainNames.length > 0 &&
							<div className={styles.tagBlock}>
								<h4 className={styles.tagHeading}>Domains</h4>
								<div className={styles.tagRow}>
									{domainNames.map((name) => <span key={`domain-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
								</div>
							</div>
						}

						{skillNames.length > 0 &&
							<div className={styles.tagBlock}>
								<h4 className={styles.tagHeading}>Skills</h4>
								<div className={styles.tagRow}>
									{skillNames.map((name) => <span key={`skill-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
								</div>
							</div>
						}

						{toolNames.length > 0 &&
							<div className={styles.tagBlock}>
								<h4 className={styles.tagHeading}>Tools</h4>
								<div className={styles.tagRow}>
									{toolNames.map((name) => <span key={`tool-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
								</div>
							</div>
						}

						{softSkillNames.length > 0 &&
							<div className={styles.tagBlock}>
								<h4 className={styles.tagHeading}>Soft Skills</h4>
								<div className={styles.tagRow}>
									{softSkillNames.map((name) => <span key={`soft-skill-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
								</div>
							</div>
						}

						{impacts.length > 0 &&
							<div className={styles.tagBlock}>
								<h4 className={styles.tagHeading}>Impacts</h4>
								<div className={styles.tagRow}>
									{impacts.map((name) => <span key={`impact-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
								</div>
							</div>
						}

						{achievements.length > 0 &&
							<div className={styles.tagBlock}>
								<h4 className={styles.tagHeading}>Achievements</h4>
								<div className={styles.tagRow}>
									{achievements.map((name) => <span key={`achievement-${item.userEntityLiveResumeId}-${name}`} className={styles.tag}>{name}</span>)}
								</div>
							</div>
						}

					</div>
				)}
			</article>
		);
	};

	renderDeleteLiveResumeDialog = () => {
		const liveResumeID = Number(this.state.confirmDeleteLiveResumeID);

		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			return null;
		}

		return (
			<HQDialog
				title="Delete Live Resume"
				message="Are you sure you want to delete this live-resume?"
				primaryButtonText="Delete"
				onPrimaryClick={this.onDeleteLiveResumeDialogPrimaryClick}
				onCancelClick={this.closeDeleteLiveResumeDialog}
				isPrimaryDisabled={this.isLiveResumeDeleting(liveResumeID)}
			/>
		);
	};

	renderAddEducationDialog = () => {
		const {
			isAddEducationDialogOpen,
			newEducationText,
		} = this.state;

		if (!isAddEducationDialogOpen) {
			return null;
		}

		return (
			<div className={styles.dialogOverlay} onClick={this.closeAddEducationDialog}>
				<div className={styles.dialogCard} onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="add-education-title">
					<button
						type="button"
						className={styles.dialogCloseButton}
						onClick={this.closeAddEducationDialog}
						aria-label="Close add education dialog"
					>
						<FiX />
					</button>

					<h3 id="add-education-title" className={styles.dialogTitle}>Add New Education</h3>
					<p className={styles.dialogSubtitle}>Tell us about your education: school name, city, state, ZIP, major, degree type, focus, and year</p>

					<textarea
						className={styles.dialogTextarea}
						value={newEducationText}
						onChange={this.onNewEducationTextChange}
						placeholder="School name, city, state, ZIP, major, degree type, focus, and year"
						rows={6}
					/>

					<div className={styles.dialogActions}>
						<button
							type="button"
							className={`${styles.primaryButton} ${styles.dialogPrimaryButton}`}
							onClick={this.onAddEducationSave}
						>
							Add
						</button>
					</div>
				</div>
			</div>
		);
	};

	renderAddExperienceDialog = () => {
		const {
			isAddExperienceDialogOpen,
			newExperienceText,
		} = this.state;

		if (!isAddExperienceDialogOpen) {
			return null;
		}

		return (
			<div className={styles.dialogOverlay} onClick={this.closeAddExperienceDialog}>
				<div className={styles.dialogCard} onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="add-experience-title">
					<button
						type="button"
						className={styles.dialogCloseButton}
						onClick={this.closeAddExperienceDialog}
						aria-label="Close add experience dialog"
					>
						<FiX />
					</button>

					<h3 id="add-experience-title" className={styles.dialogTitle}>Add New Experience</h3>
					<p className={styles.dialogSubtitle}>Tell us about your work experience: company name, city, state, ZIP, your role, and start and end date (or if you still work there)</p>

					<textarea
						className={styles.dialogTextarea}
						value={newExperienceText}
						onChange={this.onNewExperienceTextChange}
						placeholder="Company name, city, state, ZIP, your role, and start and end date (or if you still work there)"
						rows={6}
					/>

					<div className={styles.dialogActions}>
						<button
							type="button"
							className={`${styles.primaryButton} ${styles.dialogPrimaryButton}`}
							onClick={this.onAddExperienceSave}
						>
							Add
						</button>
					</div>
				</div>
			</div>
		);
	};

	render() {
		const {
			isResumeProcessing
		} = this.state;

		return (
			<div className={styles.pageContainer}>
				<Sidebar />

				<div className={styles.glowLayer}>
					<div className={styles.glowTop} />
					<div className={styles.glowBottom} />
				</div>

				<div className={styles.layoutShell}>
					<section className={styles.leftPanel}>
						{/* <div className={styles.brandBadge}>HQVibe</div> */}

						<div className={styles.profileBlock}>
							<div className={styles.avatarCircle}>{this.getInitials()}</div>
							<div>
								<h1 className={styles.title}>{this.getFullName()}</h1>
								<p className={styles.subtitle}>{utils.getUserEmail() || 'Professional Profile'}</p>
							</div>
						</div>

						<div className={styles.metricsGrid}>
							{
								isResumeProcessing && (
									<div className={styles.metricCard}>
										<span className={styles.metricLabel}><FiLoader /> Resume Processing</span>
										<strong className={styles.metricValue}>In Progress</strong>
									</div>
								)
							}

							<div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiActivity /> Total Contributions</span>
								<strong className={styles.metricValue}>{this.state.totalContributions}</strong>
							</div>

							{/* <div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiTrendingUp /> Last Active</span>
								<strong className={styles.metricValue}>{this.getLatestActiveDate()}</strong>
							</div> */}

							{/* <div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiCalendar /> Last 90 Days</span>
								<strong className={styles.metricValue}>{this.state.contributionGraph.length} tracked days</strong>
							</div> */}

							<div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiAward /> Showing Live Resume Entries</span>
								<strong className={styles.metricValue}>{this.state.recentLiveResumes.length}</strong>
							</div>

							{/* <a href="/invite">
								<div className={styles.metricCard}>
									<span className={styles.metricLabel}><FiThumbsUp /> Invite Code</span>
									<strong className={styles.metricValue}>{this.state.inviteCode}</strong>
								</div>
							</a>

							<a href="/invite">
								<div className={styles.metricCard}>
									<span className={styles.metricLabel}><FiUserPlus /> Invites Left</span>
									<strong className={styles.metricValue}>{this.state.numInvitesLeft}</strong>
								</div>
							</a> */}
						</div>

						<button className={styles.primaryButton} onClick={this.onNewLiveResumeCheckInClick}>
							New Check-in <span className={styles.btnArrow}>→</span>
						</button>
					</section>


					<div>
						{this.renderScreenTabs()}
						<section className={styles.cardPanel}>
							{this.renderCurrentScreen()}
						</section>
					</div>

					{this.renderAddEducationDialog()}
					{this.renderAddExperienceDialog()}
					{this.renderDeleteLiveResumeDialog()}
				</div>
			</div>
		);
	};
};